import styles from './CardContainer.module.css';

const CardContainer = ({children}) => {
 return (
    <div className={styles.statsCard}>{children}</div>
 )
}
export default CardContainer